import { useCallback } from 'react';
import { useAutomationRuleFormProvider } from 'src/pages/automation-rule/form';
import { actionTypes } from 'src/pages/automation-rule/form/actions';
import { initialEditWorkItem } from 'src/pages/automation-rule/form/actions/edit-work-item/use-edit-work-item';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import { triggerTypes, useAutomationRuleTrigger } from 'src/pages/automation-rule/form/trigger/use-trigger';
import { randomStringGenerator } from 'src/pages/automation-rule/form/utils/random-string-generator';

export function useCopyIterationPathFromParentWiWhenWiIsCreated() {
	const { setTitle } = useAutomationRuleFormProvider();
	const { setTrigger, setTriggerData } = useAutomationRuleTrigger();
	const { setActions } = useAutomationRuleActions();

	const copyIterationPathFromParentWiWhenWiIsCreated = useCallback(async() => {
		setTitle('When child is created copy area path and iteration from parent');
		setTrigger(triggerTypes.workItemIsCreated);
		setTriggerData(null);
		setActions([
			{
				id: randomStringGenerator(),
				action: actionTypes.editWorkItem,
				editWorkItem: {
					...initialEditWorkItem,
					relationship: 'this-work-item',
					workItemField: 'System.AreaPath',
					fieldActionValue: 'copy-field-value-from-parent-work-item',
					copyFieldValue: 'System.AreaPath',
				},
				addCommentToWorkItem: null,
				sendNotificationToSlack: null,
				sendEmailNotification: null,
				sendTeamsNotification: null,
				createdAt: new Date(),
			},
		]);
	}, []);

	return { copyIterationPathFromParentWiWhenWiIsCreated };
}
